import React from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import { IconBaseProps } from "react-icons";
import { FiSearch, FiX } from "react-icons/fi";

interface SearchInputProps {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ value, onChange, placeholder = "Search..." }) => {

  const SearchIcon = FiSearch as unknown as React.FC<IconBaseProps>;
  const ClearIcon = FiX as unknown as React.FC<IconBaseProps>;

  const handleClear = () => {
    onChange("");
  };

  return (
    <InputGroup className="position-relative">
      <FormControl
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pe-5"
        autoComplete="off"
      />

      <span
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: value ? "pointer" : "default",
          color: value ? "#666" : "#aaa",
          zIndex: 10,
        }}
        onClick={value ? handleClear : undefined}
      >
        {value ? <ClearIcon  size={18} /> : <SearchIcon size={18} />}
      </span>
    </InputGroup>
  );
};

export default SearchInput;